import React from 'react';

import { IBaseTextProps, BaseText } from './BaseText';
import {
  ITouchableProps,
  Touchable,
  TouchableTypeEnum,
} from './Touchable';

export interface ITextTouchableProps
  extends Pick<
      ITouchableProps,
      'onPress' | 'onLongPress' | 'hitSlop' | 'disabled'
    >,
    Omit<IBaseTextProps, 'onPress' | 'onLongPress'> {}

export function TextTouchable({
  onPress,
  onLongPress,
  onLayout,
  children,
  hitSlop,
  disabled,
  ...props
}: ITextTouchableProps) {
  return (
    <Touchable
      onPress={onPress}
      onLongPress={onLongPress}
      onLayout={onLayout}
      hitSlop={hitSlop}
      type={TouchableTypeEnum.Opacity}
      disabled={disabled}
    >
      <BaseText {...props}>{children}</BaseText>
    </Touchable>
  );
}
